import { render } from "./Comments.vue?vue&type=template&id=1de22d22&ts=true"
import script from "./Comments.vue?vue&type=script&lang=ts"
export * from "./Comments.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__